import { LinkButton } from '#components/atoms/buttons/link-button/LinkButton.tsx';
import { CenteredLayout } from '#components/patterns/layouts/centered/CenteredLayout.tsx';

type Props = {
  addRelayHref: string;
  className?: string;
};

/**
 * {@link EmptyRelays} is the empty state for the relay view of the hosts page, rendered inside the
 * table area so the header - search, filter, and the Type pill that got the user here - stays
 * available. The bullets explain how relay coverage works (managed lighthouses, self-hosted
 * lighthouses as relays, dedicated relays) rather than reporting per-network counts; coverage gaps
 * are the page-level NetworkCoverageBanner's job.
 */
export function EmptyRelays({ addRelayHref, className }: Props) {
  return (
    <CenteredLayout className={className}>
      <div>
        <h2 className="h3">Adding dedicated relays is recommended</h2>
        <ul className="ul-lt mb-24">
          <li>
            <a className="a" href="https://www.defined.net/docs/glossary/relay/" target="_blank" rel="help">
              Relays
            </a>{' '}
            ensure connectivity for scenarios where direct connections fail.
          </li>
          <li>Networks which enable managed lighthouses always use them as a relay.</li>
          <li>
            By default, self-hosted lighthouses are also used as relays. This is a great way to get up and running
            quickly, but dedicated relays are recommended. You can toggle this setting on the network page.
          </li>
          <li>For a high performance, high reliability network, add dedicated relays.</li>
          <li>
            Read{' '}
            <a
              className="a"
              href="https://www.defined.net/docs/guides/using-dedicated-relays/"
              target="_blank"
              rel="help"
            >
              our guide
            </a>{' '}
            for more information.
          </li>
        </ul>
        <LinkButton to={addRelayHref}>Add relay</LinkButton>
      </div>
    </CenteredLayout>
  );
}
